module.exports = __webpack_public_path__ + "img/IMG_2627.226330f9.jpg";